<template>
	<div v-if="hasVisibleIndicators">
		<!-- Top Indicator -->
		<div
			v-if="showTop"
			class="absolute top-2 left-28 flex flex-col items-center gap-1"
			@click="() => handleIndicatorClick('top')"
		>
			<img :src="arrowIcon" alt="top arrow" class="h-4 w-4" />
			<span
				class="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-white p-2 text-lg font-black text-white"
				:style="{ backgroundColor: badgeColor }"
			>
				{{ offscreenTop }}
			</span>
		</div>

		<!-- Left Indicator -->
		<div
			v-if="showLeft"
			class="absolute top-[50%] left-2 flex flex-row items-center gap-1"
			@click="() => handleIndicatorClick('left')"
		>
			<img :src="arrowIcon" alt="left arrow" class="h-4 w-4 -rotate-90" />
			<span
				class="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-white p-2 text-lg font-black text-white"
				:style="{ backgroundColor: badgeColor }"
			>
				{{ offscreenLeft }}
			</span>
		</div>

		<!-- Right Indicator -->
		<div
			v-if="showRight"
			class="absolute top-[50%] right-2 flex flex-row-reverse items-center gap-1"
			@click="() => handleIndicatorClick('right')"
		>
			<img :src="arrowIcon" alt="right arrow" class="h-4 w-4 rotate-90" />
			<span
				class="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-white p-2 text-lg font-black text-white"
				:style="{ backgroundColor: badgeColor }"
			>
				{{ offscreenRight }}
			</span>
		</div>

		<!-- Bottom Indicator -->
		<div
			v-if="showBottom"
			class="absolute left-[50%] bottom-2 flex flex-col-reverse items-center gap-1"
			@click="() => handleIndicatorClick('bottom')"
		>
			<img :src="arrowIcon" alt="bottom arrow" class="h-4 w-4 rotate-180" />
			<span
				class="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-white p-2 text-lg font-black text-white"
				:style="{ backgroundColor: badgeColor }"
			>
				{{ offscreenBottom }}
			</span>
		</div>
	</div>
</template>

<script lang="js" src="./OffscreenHotspotsIndicator.js"></script>
